<script lang="ts" setup>
import bgCta from '@images/landing-page/bg-cta.jpg'
const { locale } = useI18n()
const { $api } = useNuxtApp()
const { t } = useI18n()
const content = ref({
    content: [],
    description: '',
    title: ''
})

onMounted(() => {
    nextTick(async () => {
        const { data: contentAbout } = await $api.landingPage.getLpCta()
        content.value = contentAbout.value.data
    })
})
</script>

<template>
    <div class="cta" :style="{ backgroundImage: `url(${bgCta})` }">
        <svg class="cta__art-one" width="87" height="96" viewBox="0 0 87 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M114.028 -60C113.449 -51.6367 109.718 -43.8044 103.589 -38.085C97.4596 -32.3655 89.3882 -29.1846 81.0049 -29.1846C72.6216 -29.1846 64.5502 -32.3655 58.4209 -38.085C52.2916 -43.8044 48.5607 -51.6367 47.9814 -60L24.7666 -60C25.3384 -45.4654 31.5143 -31.716 42 -21.6348C42.5972 -21.0606 43.2068 -20.5021 43.8262 -19.957C17.8022 -6.4856 0.013862 20.6832 9.79118e-06 51.9981L37.0254 51.9981C37.0255 63.6602 41.6589 74.8445 49.9053 83.0908C58.1517 91.3372 69.3359 95.9697 80.9981 95.9697C92.6602 95.9697 103.844 91.3372 112.091 83.0908C120.337 74.8445 124.971 63.6602 124.971 51.9981L162 51.998C162 20.6864 144.216 -6.48028 118.196 -19.9531C118.817 -20.4992 119.427 -21.0595 120.025 -21.6348C130.511 -31.7161 136.687 -45.4654 137.259 -60L114.028 -60Z" fill="#FF1D25"/>
        </svg>
        <svg class="cta__art-two" width="84" height="73" viewBox="0 0 84 73" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M41.6543 3.70198e-06C41.143 7.38238 37.8498 14.296 32.4395 19.3447C27.029 24.3934 19.9041 27.2012 12.5039 27.2012C5.10374 27.2012 -2.02119 24.3934 -7.43164 19.3447C-12.842 14.296 -16.1352 7.38241 -16.6465 8.7988e-06L-37.1387 1.05903e-05C-36.634 12.8299 -31.1825 24.9663 -21.9268 33.8652C-21.399 34.3726 -20.8588 34.8651 -20.3115 35.3467C-43.2846 47.2377 -58.9878 71.2212 -59 98.8643L-26.3164 98.8643C-26.3163 109.159 -22.2274 119.031 -14.9482 126.311C-7.66904 133.59 2.20378 137.679 12.4981 137.679C22.7923 137.679 32.6651 133.59 39.9443 126.311C47.2235 119.031 51.3134 109.159 51.3135 98.8643L84 98.8643C84 71.2238 68.3004 47.2418 45.3311 35.3496C45.8793 34.8672 46.4197 34.3734 46.9482 33.8652C56.204 24.9663 61.6554 12.8299 62.1602 1.9093e-06L41.6543 3.70198e-06Z" fill="#FF1D25"/>
        </svg>


        <VContainer>
            <div class="cta__info-container">
                <div class="text-center">
                    <h2
                        class="cta__title"
                        :class="
                            $vuetify.display.smAndDown ? 'text-4xl' : 'text-5xl'
                        "
                    >
                        {{ content.title[locale] }}
                    </h2>
                    <p class="cta__description mb-7">
                        {{ content.description[locale] }}
                    </p>
                    <div class="cta__action">
                        <VBtn color="error" class="px-10" :to="{ name: 'register' }">{{
                            t('register_now')
                        }}</VBtn>
                    </div>
                    
                </div>
            </div>
            
        </VContainer>
    </div>
</template>

<style lang="scss" scoped>
.cta {
    position: relative;
    background-color: rgb(var(--v-theme-primary));
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    color: rgb(var(--v-theme-pure-white));
    padding-block: 140px;
    padding-inline: 0;
    text-align: center;

    &__info-container{
        @media only screen and (max-width: 767.98px) {
            max-width: 85%;
            margin: 0 auto;
        }
    }

    &__art-one{

        display: none;
        position: absolute;
        top: 0px;
        right: 0px;
    }
    &__art-two{
        display: none;
        position: absolute;
        bottom: 0px;
        left: 0px;
    }

    &__art-one,
    &__art-two{
        @media only screen and (max-width: 991.98px) {
             display: block;
        }
       
    }

    &__ornament {
        position: absolute;
        background-repeat: no-repeat;
        background-size: contain;
        block-size: 200px;
        inline-size: 200px;
        inset-block-start: 0;
        inset-inline-end: 0;
    }

    &__title {
        color: rgb(var(--v-theme-pure-white));
        font-family: 'Apple SD Gothic Neo', sans-serif;

        // font-size: 40px;
        font-weight: 500;
        line-height: 1.2;
        margin-block-end: 10px;
    }

    &__description {
        @include vwUnit('font-size', 21,16);
    }

    &__action{
        @media only screen and (max-width: 767.98px) {
            display: grid;
        }
    }
}

.benefits-item {
    text-align: center;

    &__title {
        font-size: 18px;
        font-weight: 500;
        margin-block: 10px;
        margin-inline: 0;
    }
}
</style>
